import { Card, CardContent, Typography, Grid } from '@mui/material';
import { useTheme } from '@emotion/react';

const CardWrapper = ({
  children,
  backgroundColor,
  height,
  icon,
  minHeight,
}) => {
  const theme = useTheme();
  const IconPrimary = icon;
  const primaryIcon = icon ? <IconPrimary fontSize='large' /> : null;

  return (
    <Card
      sx={{
        backgroundColor: backgroundColor || theme.palette.primary.main,
        position: 'relative',
        height: { xs: 'auto', lg: height },
        alignItems: 'center',
        display: 'flex',
        borderRadius: 3,
        minHeight: minHeight,
      }}
    >
      <CardContent
        sx={{
          padding: 1.5,
          '&.MuiCardContent-root:last-child': {
            padding: 1.5,
          },
          width: '100%',
        }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            sm={primaryIcon ? 8 : 12}
            md={primaryIcon ? 10 : 12}
            lg={primaryIcon ? 10.5 : 12}
            alignItems={'center'}
            display={'flex'}
          >
            {children}
          </Grid>

          {primaryIcon && (
            <Grid
              item
              justifyContent={'end'}
              alignItems={'center'}
              display={'flex'}
              width={'100%'}
              sm={4}
              md={2}
              lg={1.5}
              mt={1}
            >
              <Typography
                variant='body2'
                sx={{
                  color: '#fff',
                  '&> svg': { width: 40, height: 40, opacity: '0.7' },
                  [theme.breakpoints.down('md')]: {
                    '&> svg': { width: 30, height: 30 },
                  },
                  [theme.breakpoints.down('sm')]: {
                    '&> svg': { display: 'none' },
                  },
                }}
              >
                {primaryIcon}
              </Typography>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CardWrapper;
